import React from "react";

const LogoutComponent = () => <div>LogoutComponent</div>;

export default LogoutComponent;
